import { css } from '@emotion/css';
import {
  AlignItems,
  Color,
  Display,
  FlexDirection,
  Font,
  FontWeight,
  JustifyContent,
  SpaceSize,
  Spacing,
} from 'src/styles';

export const upload = css`
  .ant-upload-list-item-info {
    ${Spacing.mt0}
  }
`;

export const uploadFile = css`
  ${Display.flex}
  ${FlexDirection.row}
  ${JustifyContent.spaceBetween}
  ${AlignItems.center}
  ${Spacing.px16}
  ${Spacing.py12}
  border: 1px dashed ${Color.Brand2};
  background-color: ${Color.White1};
  min-height: ${SpaceSize.is80};
`;

export const iconAndEditButton = css`
  width: 100%;
  ${Display.flex}
  ${FlexDirection.row}
  ${AlignItems.center}
  ${JustifyContent.spaceBetween}
`;

export const icon = css`
  ${Font.lg}
  ${Spacing.mr8}
`;

export const filename = (danger: boolean) => css`
  ${Font.md}
  ${FontWeight.bold}
  color: ${danger ? Color.Red6 : Color.Brand6};
  ${Spacing.ml8}
`;

export const removeButtonContainer = css`
  ${Display.flex}
  ${FlexDirection.row}
  ${JustifyContent.flexEnd}
  ${Spacing.py12}
  ${Spacing.px16}
`;

export const cancelButton = css`
  min-width: unset !important;
`;
